import axios from 'axios';

import interceptors from './interceptors';

export const instance = axios.create();

instance.interceptors.response.use(...interceptors.response);
